<template>
  <div>
    <b-button v-if="question" block @click="click">
      <span v-if="answer">
        <b-icon-check />
      </span>
      {{ question.title }}
    </b-button>

    <DialogInfo v-if="answer" v-model="infoVisible" :title="question.title">
      <b-alert show>{{ question.question }}</b-alert>

      <p>
        <span class="mr-1">You said:</span>
        <span class="font-weight-bold">{{ answer }}</span>
      </p>
    </DialogInfo>
  </div>
</template>

<script>
import DialogInfo from "@/components/DialogInfo";
export default {
  name: "SurveyAnswerButton",
  components: { DialogInfo },
  props: {
    question: {
      default: null
    },
    answer: {
      default: null
    }
  },
  data() {
    return {
      infoVisible: false
    };
  },
  methods: {
    click() {
      if (this.answer) {
        this.infoVisible = true;
      } else {
        this.$emit("click", this.question);
      }
    }
  }
};
</script>
